/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect, useMemo } from 'react';
import clsx from 'clsx';
import parse from 'html-react-parser';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, EffectFade, Pagination } from 'swiper/modules';
import { useSwipeable } from 'react-swipeable';

import { useAppConfigContext } from '../../hooks/useAppConfigContext';
import { InfoPopup } from '../InfoPopup/InfoPopup';

import styles from './AboutAs.module.css';

export const AboutAs = ({
  sliderImages,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  paddingStyle,
}: {
  sliderImages: string[];
  paddingStyle: { paddingTop: number };
}) => {
  const config = useAppConfigContext();
  const [isRightExpanded, setIsRightExpanded] = useState(false);
  const [visible, setVisible] = useState(false);
  const [isOpenInfo, setOpenInfo] = useState(false);

  const toggleRightExpansion = () => {
    setIsRightExpanded((prevState) => !prevState);
  };

  const closeInfoPopup = () => {
    localStorage.setItem('isConsent', 'true');
    setOpenInfo(false);
  };

  const htmlText = useMemo(
    () => parse(config.aboutAsText),
    [config.aboutAsText],
  );

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (isRightExpanded && !visible) {
      const timeout = setTimeout(() => {
        setVisible(true);
      }, 700);
      return () => clearTimeout(timeout);
    }

    if (!isRightExpanded && visible) {
      setVisible(false);
    }
  }, [isRightExpanded]);

  useEffect(() => {
    const storedConsent = localStorage.getItem('isConsent');
    if (!storedConsent) {
      setOpenInfo(true);
    }
  }, []);

  const handlers = useSwipeable({
    onSwipedLeft: () => setIsRightExpanded(true),
    onSwipedRight: () => setIsRightExpanded(false),
    preventScrollOnSwipe: true,
  });

  return (
    <article className={styles.container}>
      <div className={styles.containerBox}>
        <Swiper
          autoFocus
          key="aboutAsSwiper"
          pagination={{
            dynamicBullets: true,
          }}
          navigation
          speed={1500}
          autoplay={{
            delay: 4500,
            disableOnInteraction: false,
          }}
          effect="fade"
          fadeEffect={{ crossFade: true }}
          modules={[EffectFade, Navigation, Autoplay, Pagination]}
        >
          {sliderImages?.map((url: any) => {
            return (
              // eslint-disable-next-line react/no-array-index-key
              <SwiperSlide key={url}>
                <div className={styles.imageBox}>
                  <img
                    className={styles.image}
                    src={url}
                    alt="Изображение кухни"
                    key={url}
                  />
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
        <div
          className={clsx(
            styles.textBox,
            isRightExpanded ? styles.textShowed : styles.textHide,
            !isRightExpanded && !visible && styles.hoverTitle,
          )}
          onClick={toggleRightExpansion}
          {...handlers}
        >
          <div className={styles.textColumn}>
            <p
              className={clsx(
                styles.title,
                !isRightExpanded ? 'opacity-100' : 'opacity-0',
                !visible ? 'visible ' : 'hidden',
              )}
            >
              О нас
            </p>
            <section
              className={clsx(
                styles.aboutAsTextContainer,
                visible ? 'visible opacity-100' : 'hidden',
                isRightExpanded ? '' : 'opacity-0',
              )}
              style={paddingStyle}
            >
              {htmlText}
            </section>
          </div>
        </div>
      </div>
      {isOpenInfo && <InfoPopup onClose={closeInfoPopup} />}
    </article>
  );
};
